import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed w-full z-50" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "flex min-h-screen flex-col pt-12 md:pt-14 pb-14 md:pb-0" }
const _hoisted_9 = { class: "w-full mt-auto pt-10" }
const _hoisted_10 = { class: "fixed w-full bottom-0 z-50" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_layouts_auth_mobile_header_well_labo = _resolveComponent("layouts-auth-mobile-header-well-labo")!
  const _component_layouts_auth_mobile_header = _resolveComponent("layouts-auth-mobile-header")!
  const _component_layouts_auth_pc_header_well_labo = _resolveComponent("layouts-auth-pc-header-well-labo")!
  const _component_layouts_auth_pc_header = _resolveComponent("layouts-auth-pc-header")!
  const _component_base_back_icon = _resolveComponent("base-back-icon")!
  const _component_layouts_auth_width = _resolveComponent("layouts-auth-width")!
  const _component_layouts_auth_contents_footer = _resolveComponent("layouts-auth-contents-footer")!
  const _component_layouts_auth_mobile_footer = _resolveComponent("layouts-auth-mobile-footer")!
  const _component_layouts_auth_sidebar = _resolveComponent("layouts-auth-sidebar")!

  return (_openBlock(), _createBlock(_component_layouts_auth_sidebar, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_ctx.store.state.base.responsive.isMD)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_ctx.only_well_labo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_layouts_auth_mobile_header_well_labo, { is_well_labo: _ctx.is_well_labo }, null, 8, ["is_well_labo"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_component_layouts_auth_mobile_header, { is_well_labo: _ctx.is_well_labo }, null, 8, ["is_well_labo"])
                      ]))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_ctx.only_well_labo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_layouts_auth_pc_header_well_labo, { is_well_labo: _ctx.is_well_labo }, null, 8, ["is_well_labo"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_component_layouts_auth_pc_header, { is_well_labo: _ctx.is_well_labo }, null, 8, ["is_well_labo"])
                      ]))
                ]))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_layouts_auth_width, null, {
          default: _withCtx(() => [
            _createVNode(_component_base_back_icon)
          ]),
          _: 1
        }),
        _renderSlot(_ctx.$slots, "default", {}, undefined, true),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_layouts_auth_contents_footer)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_ctx.store.state.base.responsive.isMD)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (!_ctx.only_well_labo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createVNode(_component_layouts_auth_mobile_footer)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _: 3
  }))
}